//#region Query params
export const AUTH_GOOGLE_OAUTH_QUERY_PARAM = "google-login-result";
export const AUTH_FACEBOOK_OAUTH_QUERY_PARAM = "fb-login-result";
export const AUTH_APPLE_OAUTH_QUERY_PARAM = "apple-login-result";
//#endregion

//#region Google
export enum AuthGoogleScope {
  EMAIL = "email",
  PROFILE = "profile",
  CALENDAR = "https://www.googleapis.com/auth/calendar",
  CONTACTS_READONLY = "https://www.googleapis.com/auth/contacts.readonly",
  CONTACTS_OTHER_READONLY = "https://www.googleapis.com/auth/contacts.other.readonly",
  DIRECTORY_READONLY = "https://www.googleapis.com/auth/directory.readonly",
  DRIVE_METADATA = "https://www.googleapis.com/auth/drive.metadata.readonly",
}

export const AUTH_DEFAULT_GOOGLE_SCOPES = [AuthGoogleScope.EMAIL, AuthGoogleScope.PROFILE] as const;

export const AUTH_GOOGLE_REDIRECT_SCOPE = [
  "https://www.googleapis.com/auth/userinfo.email",
  "https://www.googleapis.com/auth/userinfo.profile",
].join(" ");
//#endregion
